import { Action } from 'redux'

import { HttpError } from 'modules/http-client'

import { User } from '../models'

export const GET_CURRENT_USER = '[auth] Get Current User'
export const GET_CURRENT_USER_SUCESS = '[auth] Get Current User Sucess'
export const GET_CURRENT_USER_ERROR = '[auth] Get Current User Error'

export const LOGIN_AS = '[auth] Login as'
export const LOGIN_AS_SUCESS = '[auth] Login as Sucess'
export const LOGIN_AS_ERROR = '[auth] Login as Error'

export class CurentUserAction implements Action {
  readonly type = GET_CURRENT_USER
}
export class CurentUserSuccessAction implements Action {
  readonly type = GET_CURRENT_USER_SUCESS
  constructor(public payload: User) {}
}
export class CurentUserFailureAction implements Action {
  readonly type = GET_CURRENT_USER_ERROR
  constructor(public payload: HttpError) {}
}

export const LOGOUT = '[auth] Logout'
export const LOGOUT_SUCCESS = '[auth] Logout success'
export const LOGOUT_FAILED = '[auth] Logout failed'

export class LogoutAction implements Action {
  readonly type = LOGOUT
}
export class LogoutSuccessAction implements Action {
  readonly type = LOGOUT_SUCCESS
}
export class LogoutFailedAction implements Action {
  readonly type = LOGOUT_FAILED
}

export class LoginAsAction implements Action {
  readonly type = LOGIN_AS
  /**
   * @param payload userName
   */
  constructor(public payload: string) {}
}
export class LoginAsSuccessAction implements Action {
  readonly type = LOGIN_AS_SUCESS
  constructor(public payload: User) {}
}
export class LoginAsFailureAction implements Action {
  readonly type = LOGIN_AS_ERROR
  constructor(public payload: HttpError) {}
}

export type AuthActions =
  | CurentUserAction
  | CurentUserSuccessAction
  | CurentUserFailureAction
  | LogoutAction
  | LogoutSuccessAction
  | LogoutFailedAction
  | LoginAsAction
  | LoginAsSuccessAction
  | LoginAsFailureAction



// WEBPACK FOOTER //
// ./src/app/auth/store/auth.actions.ts